import { createAction, props } from '@ngrx/store';

import { Notification } from '../models/notification.model';

export const loadNotificationsRequest = createAction('[Notification] Load Notifications request');

export const loadNotificationsSuccess = createAction('[Notification] Load Notifications success', props<{ notifications: Notification[] }>());

export const loadNotificationsFailure = createAction('[Notification] Load Notifications failure');

export const upsertNotificationRequest = createAction('[Notification] Upsert Notification request', props<{ notification: Notification }>());

export const upsertNotificationSuccess = createAction('[Notification] Upsert Notification success', props<{ notification: Notification }>());

export const upsertNotificationFailure = createAction('[Notification] Upsert Notification failure', props<{ error: string }>());

export const softDeleteNotificationRequest = createAction('[Notification] Soft Delete Notification request', props<{ id: number }>());

export const softDeleteNotificationSuccess = createAction('[Notification] Soft Delete Notification success', props<{ id: number }>());

export const softDeleteNotificationFailure = createAction('[Notification] Soft Delete Notification failure', props<{ error: string }>());
